import { Injectable } from '@angular/core';

import { AtlasenseapiService } from '../api.service';
import { ConfigurationService } from '../config.service';

import { App } from './app';

const APP_ENDPOINT = 'app';

@Injectable()
export class AppService {

  constructor(
    public api: AtlasenseapiService,
    public config: ConfigurationService) {}

  getApp(id: string): App{
    // Mock app
    let app: App = {
      "name": "Discovery App",
      "installed_version": "1.0",
      "last_version": "2.0",
      "description": "Discovery app description ...",
      "id": "111111",
      "price": 20.22
    }
    return app;

  }

  getApps(): App[]{

    // Mock apps
    let apps: App[] = [
      {
        "name": "Contact Classifier",
        "installed_version": "2.1",
        "last_version": "2.1",
        "description": "Contact Classifier description ...",
        "id": "12312",
        "price": 12.00
      },
      {
        "name": "Atlas Vault",
        "installed_version": "1.0",
        "last_version": "1.0",
        "description": "Atlas Vault description ...",
        "id": "44444",
        "price": 21.00
      },
      {
        "name": "Legal Hold",
        "installed_version": "3.2",
        "last_version": "3.2",
        "description": "Legal Hold description ...",
        "id": "55555",
        "price": 38.00
      },
      {
        "name": "Compliance",
        "installed_version": "2.4",
        "last_version": "2.4",
        "description": "Compliance description ...",
        "id": "66666",
        "price": 102.00
      },
      {
        "name": "Other app",
        "installed_version": "1.2",
        "last_version": "1.2",
        "description": "Other app description ...",
        "id": "77777",
        "price": 75.00
      }
    ]
    return apps;
  }

}
